/**
 * NEX-1165 (W2-hard-a, decision A1) — "same zone" (department + locality), the panel's mirror of
 * nexvia-api-web `src/modules/storage/domain/zone-match.ts` (whose SQL mirrors
 * `Locality.normalizeId`): trim, lowercase, drop accents, drop punctuation, whitespace runs to one
 * dash, dash runs to one dash. "Dr Francisco Soca" = "Dr. Francisco Soca"; "Fray Bentos" and "Young"
 * stay different. The API refuses a quote from a location outside the request's zone (422
 * `STORAGE_QUOTE_LOCATION_OUT_OF_ZONE`), so the quote form offers only the locations this accepts.
 * Change both sides together.
 */
export function normalizeZoneName(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-');
}

export interface Zone {
  department: string;
  locality: string;
}

export function isSameZone(a: Zone, b: Zone): boolean {
  return normalizeZoneName(a.department) === normalizeZoneName(b.department) && normalizeZoneName(a.locality) === normalizeZoneName(b.locality);
}
